import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formDataFromServerShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import { COORDINATOR, ES_VIEWING_NEW_SECTION, VIEWING_CRQ } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { COMPLETION_REVIEW } from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import {
  withRouter,
  // useHistory,
} from 'react-router-dom';
import {
  getFowardTransition,
  // CRQ_STATUS_TRANSITIONS,
} from 'AppSrc/core/crq/crq-status-transitions';
import { GetCompletionReviewSection } from 'AppSrc/core/components/forms/form-types/completion-review/get-completion-review-section';
import { getSectionOneCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/section-one';
import { getSectionTwoCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-two/section-two';
import { getSectionThreeCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-three/section-three';
import { getSectionCiCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-ci/section-ci';
import { getSectionFailureCurrentFields } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/section-failure';
import { CompletionSubmitModal } from 'AppSrc/core/components/view-crq-screen/modals/completion-submit-modal';
// import { SectionCompletionReviewSummary } from 'AppSrc/core/components/forms/form-base-components/summary-components/section-completion-review-summary';
// import { START_AND_END_DATE } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/section-three';
import moment from 'moment';
import {
  saveSectionDataForEditFormThunk,
  fetchCrqForViewEdit,
} from 'AppSrc/core/actions/actions-edit-form';
import { updateCrqRelationships } from 'AppSrc/core/relationships/relationships-actions';
import { updateEditCrqWithId } from 'AppSrc/core/actions/actions-update-edit-form';
import {
  isStatusCompleted,
  isStatusClosed,
} from 'AppSrc/core/crq/crq-statuses';
import {
  getStatusReasonTextParameter,
  isUnsuccessfulStatusReason,
} from 'AppSrc/core/crq/crq-status-reasons';
// import { ViewCrqEngineerResponsesReview } from './view-crq-engineer-response-review';
import { CRQ_TRANSITION_CONFIRMATION } from 'AppSrc/core/components/router/routes';
import { Loader } from 'AppSrc/core/components/utility/loader';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { getUnsavedRelationshipsCompletion } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-section-logic';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-completion-review.css';

const sectionId = COMPLETION_REVIEW;

const getCurrentFields = ({
  values,
  network,
  formData,
  isOLO,
}) => {
  const { statusReason, status } = formData;
  const isUnsuccessful = isUnsuccessfulStatusReason(statusReason, network);
  const SectionOne = getSectionOneCurrentFields({
    values,
    network,
    isOLO,
    formData,
  });

  const SectionTwo = getSectionTwoCurrentFields({ formData, isOLO });
  const SectionThree = getSectionThreeCurrentFields({ network, isOLO, isUnsuccessful });

  const currentFields = [...SectionOne];
  // OLO CRQ need to set all post change answers to Unknown
  if (isOLO) {
    return [
      ...SectionOne,
      ...SectionTwo,
      ...SectionThree,
    ];
  }
  // if statusReason is unsuccessful and status is completed
  // then will need to get Failure section fields
  if (isUnsuccessful && (isStatusCompleted(status) || isStatusClosed(status))) {
    const SectionFailureReview = getSectionFailureCurrentFields();
    currentFields.push(...SectionFailureReview);
  }
  if (network === MOBILE) {
    const SectionCi = getSectionCiCurrentFields();
    currentFields.push(...SectionTwo, ...SectionCi);
  }
  if (network === FIXED) {
    currentFields.push(...SectionTwo);
  }
  currentFields.push(...SectionThree);
  return currentFields;
};

const ViewCrqCompletionReviewDisplay = ({
  formData,
  network,
  userRoles,
  remedyId,
  crqId,
  updateSectionData,
  saveSectionData,
  LoadScreen,
  errorAlert,
}) => {
  const [modalDisplay, setModalDisplay] = useState(false);
  const [statusReasonText, setStatusReasonText] = useState('');
  const [summaryRead, setSummaryRead] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const {
    status,
    dataByFormSectionId,
    coordinatorId,
    otherLineOperator,
  } = formData;
  const {
    statusReason,
  } = formData;
  // The engineer response review is showed only if the user role is assigned fixed coordinator
  const isAssigned = remedyId === coordinatorId;
  // const isFixedCoordinator = network === FIXED && userRoles[FIXED] === COORDINATOR;
  // const isAssignedFixedCoordinator = isFixedCoordinator && isAssigned;

  const isOLO = otherLineOperator === 'Yes';

  useEffect(() => {
    const isCoordinator = userRoles[network] === COORDINATOR;
    const isAssignedCoordinator = isCoordinator && isAssigned;
    const abc = 'actual_end_date';
    // const scheduledEndDate = dataByFormSectionId[START_AND_END_DATE].dataByFieldId['scheduled-end-date'].value;
    const scheduledEndDate = dataByFormSectionId[COMPLETION_REVIEW].dataByFieldId[abc] ? dataByFormSectionId[COMPLETION_REVIEW].dataByFieldId[abc].value : null;
    // over 72 hours after scheduled end date
    const over72Hours = statusReason === '6200' || statusReason === 'Unsuccessful' ? false : moment(new Date()).diff(scheduledEndDate, 'h') > 72;
    const isCorrectState = isStatusCompleted(status) || isStatusClosed(status);
    // set readOnly
    const readOnly = status === '11' ? true : (isCorrectState && !isOLO && (!isAssignedCoordinator || (isAssignedCoordinator && over72Hours)));
    setSummaryRead(readOnly);
  }, [dataByFormSectionId, isAssigned, isOLO, network, status, userRoles, statusReason]);


  const handleSuccessfulSubmit = (sectionData, newStatus, successPath) => {
    const val = sectionData.dataByFieldId.status_reason.value;
    const statusReasonTextParameter = getStatusReasonTextParameter(val, network);

    setStatusReasonText(statusReasonTextParameter);
    setSubmitting(true);
    updateSectionData(crqId, sectionData, newStatus, successPath, network)
      .then((response) => {
        setSubmitting(false);
      })
      .catch((error) => {
        console.error(error);
        errorAlert({
          errorTitle: 'Failed update CRQ',
          errorText: 'Sorry we are unable to update your CRQ due to a technical issue. Please try again later.',
        });
        setSubmitting(false);
      });
  };
  // const history = useHistory();
  const closeModal = () => {
    setModalDisplay(false);
    LoadScreen(crqId, formData.network);
    window.location.reload();
    // history.push('/mycrq/fixed/My%20Fixed%20CRQs');
    // console.log(history, 'history');
    // history.go(0);
  };
  if (isSubmitting) {
    // set up a loader array that shows the loader at half loaded
    // TODO ideally this would be based on redux in terms of how many approvers have been saved
    const loaderArray = [true, false];
    return (
      <Loader
        loaderArray={loaderArray}
        loaderTitle="Please wait whilst we update your CRQ"
        loaderText="Do not close or refresh your browser whilst we do this."
      />
    );
  }
  return (
    <div className="view-crq-completion-review">
      {/* {
      (isAssignedFixedCoordinator && !isOLO) ? (
        <ViewCrqEngineerResponsesReview />
      ) : null
      } */}
      <GetCompletionReviewSection
        network={network}
        handleSuccessfulSubmit={handleSuccessfulSubmit}
        formData={formData}
        sectionId={sectionId}
        isOLO={isOLO}
        saveSectionData={saveSectionData}
        summaryRead={summaryRead}
        setModalDisplay={setModalDisplay}
        crqId={crqId}
        getCurrentFields={() => getCurrentFields({
          values: {},
          network,
          formData,
          isOLO,
        })}
      />
      {
        modalDisplay && (
          <CompletionSubmitModal
            closeModal={closeModal}
            statusReasonText={statusReasonText}
          />
        )
      }
    </div>
  );
};

ViewCrqCompletionReviewDisplay.propTypes = {
  network: PropTypes.string,
  userRoles: PropTypes.objectOf(PropTypes.string),
  remedyId: PropTypes.string,
  formData: formDataFromServerShape,
  crqId: PropTypes.string,
  updateSectionData: PropTypes.func,
  saveSectionData: PropTypes.func,
  LoadScreen: PropTypes.func,
  errorAlert: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
  updateSectionData: (crqId, sectionData, targetStatus, successPath, network) => {
    // const statusTransition2 = getFowardTransition({ currentStatus: ownProps.formData.status });
    const statusReasonValue = sectionData.dataByFieldId.status_reason.value;
    let statusTransition = '';
    if (ownProps.formData.status === '10' && (statusReasonValue === 'Unsuccessful' || statusReasonValue === '6200')) {
      statusTransition = getFowardTransition({ currentStatus: ownProps.formData.status, formData: ownProps.formData, statusReasonValue });
    }
    if (ownProps.formData.status === '10' && (statusReasonValue === 'Successful' || statusReasonValue === '5000')) {
      // statusTransition = ownProps.formData.otherLineOperator === 'Yes' ? '11' : '10';
      statusTransition = getFowardTransition({ currentStatus: ownProps.formData.status, formData: ownProps.formData, statusReasonValue });
    }
    else {
      statusTransition = getFowardTransition({ currentStatus: ownProps.formData.status, formData: ownProps.formData, statusReasonValue });
    }
    dispatch(saveSectionDataForEditFormThunk({ crqId, sectionData, editingStatus: ES_VIEWING_NEW_SECTION }));
    // const SectionCi = getSectionCiCurrentFields();
    return dispatch(updateEditCrqWithId(crqId, statusTransition))
      .then((respose) => {
        if (ownProps.formData.status === '10') {
          dispatch(fetchCrqForViewEdit({
            editingStatus: ES_VIEWING_NEW_SECTION,
            crqId,
            network,
          }));
        }
        if (statusTransition.targetStatus === '11') {
          // const viewCrqPath = VIEW_CRQ.getPath({ network, crqId });
          // const history = useHistory();
          // history.go(0);
          const successPaths = CRQ_TRANSITION_CONFIRMATION.getPath({
            network,
            crqId,
            transitionId: statusTransition.id,
          });
          ownProps.history.push(successPaths);
        }
      }).then(() => {
        const unsavedRelationships = network === 'mobile' ? getUnsavedRelationshipsCompletion(sectionData) : [];
        dispatch(updateCrqRelationships({
          crqId,
          unsavedRelationships,
          formFlow: VIEWING_CRQ,
        }));
      });
  },
  saveSectionData(sectionData) {
    const {
      crqId,
    } = ownProps;
    dispatch(saveSectionDataForEditFormThunk({ crqId, sectionData, editingStatus: ES_VIEWING_NEW_SECTION }));
  },
  LoadScreen(crqId, network) {
    // const network = currentSelectedNetwork(formData);
    dispatch(fetchCrqForViewEdit({
      editingStatus: ES_VIEWING_NEW_SECTION,
      crqId,
      network,
    }));
  },
});

const ViewCrqCompletionReview = withRouter(connect(
  null,
  mapDispatchToProps,
)(ViewCrqCompletionReviewDisplay));

export {
  ViewCrqCompletionReview,
  getCurrentFields,
  COMPLETION_REVIEW,
};
